import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'


export const countryTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'COUNTRIES');


export const requestCountries = () => {
    return {
        type: countryTypes.REQUEST,
    };
};

export const receiveCountries = (response) => {
    return {
        type: countryTypes.RECEIVE,
        data: response,
    };
};

export const receiveCountriesError = (response) => {
    return {
        type: countryTypes.ERROR,
        error: response,
    };
};

export const getCountries = () => {
    return dispatch => {

        let apiUrl = `/api/v1/countries/`

        dispatch(requestCountries());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveCountries(response));
            } catch (e) {
                dispatch(receiveCountriesError(response));
            }
        })
        .catch(handleNetworkError);
    };
};